module.exports = __webpack_public_path__ + "img/trash-icon.4e4ae5ac.svg";